import { gql } from '@apollo/client';

export default gql`
  mutation createPaymentLink($bookingReference: String!, $amount: Float!, $currency: Currency!, $reason: String) {
    createPaymentLink(bookingReference: $bookingReference, amount: $amount, currency: $currency, reason: $reason)
  }
`;
